/** YYYY-MM-DD for the device's local day (toISOString() is UTC: tomorrow on US evenings). */
export function localDateString(date = new Date()) {
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
